import { inject, Injectable } from '@angular/core';
import { PharmacyChainService } from '@services/pharmacy-chains/pharmacy-chain.service';
import { SourceFilterOptionsLoader } from '@shared/dataview/options/filter-options.registry';
import { SelectListItem } from '@shared/models/select-list-item';
import { map, Observable } from 'rxjs';

const MAX_CHAINS = 1000;

@Injectable({ providedIn: 'root' })
export class PharmacyChainsOptionsLoader extends SourceFilterOptionsLoader {
  readonly source = 'pharmacyChains';

  private readonly pharmacyChainService = inject(PharmacyChainService);

  load(): Observable<SelectListItem[]> {
    return this.pharmacyChainService.search({}, { pageSize: MAX_CHAINS }).pipe(
      map(result =>
        (result.items ?? []).map(chain => ({
          name: chain.name ?? `UNKNOWN (${chain.npi})`,
          value: chain.npi,
        })),
      ),
    );
  }
}
